module.exports = __webpack_public_path__ + "70c9f41c0e5b0eb0a59c97aafc5300c0.svg";